import { render, staticRenderFns } from "./my-dialog.vue?vue&type=template&id=8b422f80&scoped=true"
import script from "./my-dialog.vue?vue&type=script&lang=js"
export * from "./my-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b422f80",
  null
  
)

export default component.exports